import { createReducer } from '@reduxjs/toolkit'

import * as authenticationActions from 'redux/actions/Authentication/actions'
import * as actions from 'redux/actions/DataPlatform/tables/v4/actions'
import * as sourceSchemaActions from 'redux/actions/DataPlatform/sourceSchemas/v2/actions'

import { CollectSchema, SourceTable } from 'types/GlobalDataset'
import { SimTable } from 'types/transformation/types/tables'

export interface SimTableReducerType {
  data: SimTable | null
  sourceSchemas: CollectSchema
  fetchingSources: boolean
  sourcesFetched: boolean
}

const INITIAL_STATE: SimTableReducerType = {
  data: null,
  sourceSchemas: {},
  fetchingSources: false,
  sourcesFetched: false
}

const simTableReducer = createReducer(INITIAL_STATE, (builder) => {
  builder
    .addCase(actions.getOneSIMTable, (state) => {
      return {
        ...state,
        data: null
      }
    })
    .addCase(actions.getOneSIMTableSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        data: payload
      }
    })
    .addCase(actions.getOneSIMTableFailed, (state) => {
      return {
        ...state,
        data: null
      }
    })
    .addCase(actions.putSIMTableSuccess, (state, action) => {
      const { payload } = action

      return {
        ...state,
        data: payload
      }
    })
    .addCase(sourceSchemaActions.getSourceSchemas, (state) => {
      return {
        ...state,
        fetchingSources: true,
        sourcesFetched: false
      }
    })
    .addCase(sourceSchemaActions.getSourceSchemasSuccess, (state, action) => {
      const { payload } = action

      const sourceSchemas: CollectSchema = {}

      payload.forEach((source) => {
        const tableMapper: { [id: string]: SourceTable } = {}

        source.tables.forEach((table) => {
          tableMapper[table.value] = table
        })

        sourceSchemas[source.value] = {
          ...source,
          tables: tableMapper
        }
      })

      return {
        ...state,
        sourceSchemas,
        fetchingSources: false,
        sourcesFetched: true
      }
    })
    .addCase(sourceSchemaActions.getSourceSchemasFailed, (state) => {
      return {
        ...state,
        fetchingSources: false,
        sourcesFetched: true
      }
    })
    .addCase(authenticationActions.signOut, () => INITIAL_STATE)
    .addDefaultCase((state) => state)
})

export default simTableReducer
